new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_header',
    data: {
        header: {
          useFirst: true, // first headerBar
          myaccount_options: 'dropdown', // 'none' = no dropdowns, 'dropdown' = hover and dropdown menu;
          isNavUp: true,
          isNavDown: true,
          isNavMin: false,
          lastScrollTop: 0,
          menuMobile: false,
          openCategorysMobile: false,
        },
        searchOpened: false,
        cartOpened: false,
    },
    methods: {
      addPaddingHeader() {
        const headerTransparent = document.querySelector('.nav-up');
        const header = document.querySelector('#app_header');
        const headerHeight = header.clientHeight;
        const mainTag = document.querySelector('main[role="main"]');
        const mainDiv = document.querySelector('.main-content');

        if(headerTransparent) {
          if(view_origin != "home") {
            if (mainTag) {
              mainTag.style.paddingTop = `${headerHeight}px`;
            } else {
              mainDiv.style.paddingTop = `${headerHeight}px`;
            }
          }
        } else {
          if (mainTag) {
            mainTag.style.paddingTop = `${headerHeight}px`;
          } else {
            mainDiv.style.paddingTop = `${headerHeight}px`;
          }
        }  
      },
      runSpeechRecognition() {
        var isChromium = window.chrome;
        var winNav = window.navigator;
        var vendorName = winNav.vendor;
        var isOpera = typeof window.opr !== "undefined";
        var isIEedge = winNav.userAgent.indexOf("Edge") > -1;
        var isIOSChrome = winNav.userAgent.match("CriOS");

        if(isChromium !== null && typeof isChromium !== "undefined" && vendorName === "Google Inc." && isOpera === false && isIEedge === false) {
          let output = document.querySelector(".output-search");
          let action = document.querySelector(".microphone");
          let inputMic = document.querySelector(".search__text");
      
          var SpeechRecognition = SpeechRecognition || webkitSpeechRecognition;
  
          var recognition = new SpeechRecognition();
          recognition.continuous = false;
          recognition.lang = 'pt-BR';
  
      
          recognition.onstart = function() {
          if (!output.classList.contains("hide")) {
              output.classList.toggle("hide");
          }   
          
          action.classList.toggle('active');
          };
          
          recognition.onspeechend = function() {
          
          action.classList.toggle('active');
              recognition.stop();
          }
      
          recognition.onresult = function(event) {
              var transcript = event.results[0][0].transcript;
              var confidence = event.results[0][0].confidence * 100;
          
              if(confidence < 50) {
                  inputMic.classList.toggle('not-understand')
                  output.classList.toggle("hide");
                  inputMic.value = "Desculpe não entendi muito bem.";
              } else {
                  inputMic.value = transcript
                  document.querySelector('.search__submit').click()
              };
              
          };
      
          // start recognition
          recognition.start();
        } else return document.querySelector(".microphone-search").remove();
      },
      handleScroll() {
          const st = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
          const scrollDifference = st - this.lastScrollTop;
          const customMobile = document.getElementById('custom-mobile-nav');
          const headerThird = document.getElementById('header-third');
          const quickMenu = document.getElementById('quick-menu-id');
          const whatsappWidget = document.getElementById('widget-whatsapp');

          if (st > this.lastScrollTop)
              this.header.isNavUp = false;
          else {
              if (st === 0) 
                this.header.isNavUp = true;
          }

          if (st >= 90 && scrollDifference > 0) {
            this.header.isNavDown     = false;
            this.header.isNavMin      = true;

            if (customMobile)
              customMobile.classList.add('hide');

            if (headerThird)
              headerThird.classList.add('hide');

            if (quickMenu) {
              quickMenu.classList.add('hide');
              whatsappWidget.style.bottom = '';
            }

          } else {
            this.header.isNavDown     = true;
            this.header.isNavMin      = false;
            this.header.isNavMenuHide = false;

            if (customMobile)
              customMobile.classList.remove('hide');

            if (headerThird)
              headerThird.classList.remove('hide');

            if (quickMenu) {
              quickMenu.classList.remove('hide');
              whatsappWidget.style.bottom = '79px';
            }
          }

          this.lastScrollTop = st;
      },
      filterItems(item1, item2, item3, item4) {
        var data = [item1, item2, item3, item4];

        for (var i = 0; i < data.length; i++) {
          var element = document.querySelector('[item="' + data[i] + '"]');
          switch (data[i]) {
            case "home":
                element.setAttribute('href', '/');
                break;
            case "menu":
                var newSpan = document.createElement('span');
                newSpan.setAttribute('class', 'quick-menu__item--link toggleMenu js-mobile-nav-trigger');

                while (element.firstChild) {
                  newSpan.appendChild(element.firstChild);
                }

                element.parentNode.replaceChild(newSpan, element);
                break;
            case "cart":
                element.setAttribute('href', '/carrinho');
                break;
            case "user":
                element.setAttribute('href', '/clientes/identificacao/?next=/clientes/minha-conta/');
                break;
            case "wishlist":
                element.setAttribute('href', '/clientes/minha-conta/minha-lista-de-produtos/');
                break;
          }
        }
      },
      setupMarquee() {
        const marquee = document.querySelector('.texto-header__list');
        if (!marquee) return;

        // Pega todos os itens originais
        const originalItems = Array.from(marquee.querySelectorAll('li'));
        const totalWidth = originalItems.reduce((acc, item) => acc + item.offsetWidth, 0);
        const screenWidth = window.innerWidth;

        // Calcula quantas vezes precisamos duplicar para garantir preenchimento
        const timesToDuplicate = Math.ceil((screenWidth) / totalWidth) + 1;

        // Limpa o marquee
        marquee.innerHTML = '';

        // Adiciona os itens duplicados
        for (let i = 0; i < timesToDuplicate; i++) {
          originalItems.forEach(item => {
            const clone = item.cloneNode(true);
            marquee.appendChild(clone);
          });
        }

        // Ajusta a animação baseado no conteúdo total
        const finalWidth = marquee.scrollWidth;
        // Aumentando a velocidade da animação
        const duration = finalWidth / 20;

        marquee.style.animation = `none`;
        setTimeout(() => {
          marquee.style.animation = `marquee ${duration}s linear infinite`;
        }, 0);
      },
    },
    mounted() {
      this.addPaddingHeader();
      this.setupMarquee();

      const btnContinue = document.querySelector('.cart-preview .btn-continue');
      if(btnContinue) {
        btnContinue.addEventListener('click', () => {
          $('.cart-preview--overlay').removeClass('active');
          $('.cart-preview').removeClass('active');
          document.body.classList.remove('no-scroll');
          $('.cart-preview').removeClass('cupom-active');
          $('.cart-preview--overlay').removeClass('cupom-active');
        });
      }

      //window.addEventListener('scroll', this.handleScroll);

      let item1, item2, item3, item4

      if(document.getElementById('quick-item-1')) {
        item1 = document.getElementById('quick-item-1').getAttribute('item');
      }
      if(document.getElementById('quick-item-2')) {
        item2 = document.getElementById('quick-item-2').getAttribute('item');
      }
      if(document.getElementById('quick-item-3')) {
        item3 = document.getElementById('quick-item-3').getAttribute('item');
      }
      if(document.getElementById('quick-item-4')) {
        item4 = document.getElementById('quick-item-4').getAttribute('item');
      }
      
      if(item1 && item2 && item3 && item4) {
        this.filterItems(item1, item2, item3, item4);
      }
    },
    beforeDestroy() {
      //window.removeEventListener('scroll', this.handleScroll);
    },
})

// window.addEventListener('load', () => {
//   const loader = document.getElementById('loader');
//   loader.style.opacity = '0';

//   // Espera um pouco para garantir a transição suave
//   setTimeout(() => {
//     loader.style.display = 'none';
//   }, 500); // tempo em ms (mesmo que a transição)
// });

var cart_preview_triggers = $('.header__second--tools-cart, .cart-preview-close, .cart-preview-header__close');

cart_preview_triggers.on("click", function (e) {
  if($(window).width() >= 970) {
    // e.preventDefault();
  };

  $('.cart-preview--overlay').toggleClass('active');
  $('.cart-preview').toggleClass('active');
  document.body.classList.toggle('no-scroll');
  $('.cart-preview').removeClass('cupom-active');
  $('.cart-preview--overlay').removeClass('cupom-active');
});

var cart_service = new CartService();
$('.delete-item').on('click', function (event) {
  cart_service.removeCartItem();
  window.sessionStorage.removeItem(`cart-preview-cache-${base_url}`);
});

if(window.outerWidth > 991) {
  $(".header__cart__wrap").click(function(e){
    e.preventDefault();
    $('.cart-preview').addClass('active');
    $('.cart-preview--overlay').addClass('active');
    document.body.classList.add('no-scroll');
  });

  $('.cart-preview--overlay').click(function(e){
    e.preventDefault();
    $('.cart-preview').removeClass('active');
    $('.cart-preview--overlay').removeClass('active');
    $('.cart-preview').removeClass('cupom-active');
    $('.cart-preview--overlay').removeClass('cupom-active');
    document.body.classList.remove('no-scroll');
  })

  $('.cart-preview-header__close').click(function(e) {
    e.preventDefault();
    $('.cart-preview').removeClass('active');
    $('.cart-preview--overlay').removeClass('active');
    $('.cart-preview').removeClass('cupom-active');
    $('.cart-preview--overlay').removeClass('cupom-active');
    document.body.classList.remove('no-scroll');
  }) 
}